import type { ReactNode } from 'react';
import { useEmbedHost } from '@/contexts/EmbedHostContext';

interface PublicChromeProps {
  children: ReactNode;
  /** Full public layout chrome (nav/footer) when not embed mode */
  chrome?: ReactNode;
}

/**
 * Wraps public tenant pages. In embed mode (`?embed=1`), strips outer chrome and uses compact padding.
 */
export function PublicChrome({ children, chrome }: PublicChromeProps) {
  const { isEmbedMode } = useEmbedHost();

  if (isEmbedMode) {
    return (
      <div className="embed-mode min-h-0 bg-background p-3 sm:p-4" data-embed-mode="true">
        {children}
      </div>
    );
  }

  if (chrome) {
    return <>{chrome}</>;
  }

  return <>{children}</>;
}
